module.exports = __webpack_public_path__ + "static/media/si-p-hardcoreblasters.728f66d9.svg";